import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './Header.css';

const Header = () => {
    const { language, setLanguage, t } = useLanguage();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const languages = [
        { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'ru', name: 'Русский', flag: '🇷🇺' },
        { code: 'ar', name: 'العربية', flag: '🇸🇦' }
    ];

    return (
        <header className="header">
            <div className="container">
                <div className="header-content">
                    <Link to="/" className="logo">
                        <span className="logo-icon">🚕</span>
                        <span className="logo-text">elittaksibodrum</span>
                    </Link>

                    <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
                        <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                            {t('home')}
                        </Link>
                        <Link to="/vehicles" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                            {t('vehicles')}
                        </Link>
                        <Link to="/reservation" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                            {t('reservation')}
                        </Link>
                    </nav>

                    <div className="header-actions">
                        <div className="language-selector">
                            <select 
                                value={language} 
                                onChange={(e) => setLanguage(e.target.value)}
                                className="language-select"
                            >
                                {languages.map(lang => (
                                    <option key={lang.code} value={lang.code}>
                                        {lang.flag} {lang.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <button 
                            className="mobile-menu-btn"
                            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                            aria-label="Menu"
                        >
                            {mobileMenuOpen ? '✕' : '☰'}
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
